/** Labels der Hero-Eigenfelder, die als native Projektfelder geführt werden. */

export function normalizeReferenzLabel(label: string | null | undefined): string {
  return String(label || "")
    .trim()
    .toLowerCase()
    .replace(/[\s\-_/().]+/g, "");
}

const KUNDENREFERENZ_LABELS = new Set(
  [
    "kundenreferenz",
    "kunden referenz",
    "kunden-referenz",
    "kunden referenznummer",
    "kunden-referenznummer",
    "kundenreferenznummer",
    "kundenreferenz / kommission",
    "kunden referenz / kommission",
    "kunden-referenz / kommission",
    "kundenreferenz (extern)",
    "kunden referenz (extern)",
    "kunden-referenz (extern)",
    "referenz",
    "referenznummer",
  ].map(normalizeReferenzLabel),
);

const BESTELLNUMMER_LABELS = new Set(
  [
    "bestellnummer",
    "bestell-nummer",
    "bestell nr",
    "bestell-nr",
    "kundenbestellnummer",
    "kunden-bestellnummer",
    "kunden bestellnummer",
    "po",
    "po-nummer",
    "po nummer",
    "purchase order",
  ].map(normalizeReferenzLabel),
);

export function isClaimedHeroCustomFieldLabel(label: string | null | undefined): boolean {
  const key = normalizeReferenzLabel(label);
  if (!key) return false;
  return KUNDENREFERENZ_LABELS.has(key) || BESTELLNUMMER_LABELS.has(key);
}
